<template>
  <div
    id="dragItem"
    class="gd-ribbon"
    :class="{ active: isActive }"
    @click="toggleSocialBar()"
  >
    <!-- <img class="gd-logo" src="/public/favicon.ico"> -->
    <social-bar
      v-show="socialBarOpen"
      @toggle="toggleSocialBar"
      class="gd-social-bar"
    ></social-bar>
    <!-- <img
      class="gd-logo-plus"
      src="../../public/img/plus_banner.png"
      @click="toggleSocialBar()"
    /> -->
    <span
      class="badge  drag-deactive-badge"
      v-if="
        isActive !== true && !user.is_guest && unseenNotificationCount !== 0
      "
      >{{ unseenNotificationCount }}</span
    >
  </div>
</template>

<script>
import SocialBar from "./SocialBar";
export default {
  name: "DragBar",
  props: {},
  components: { SocialBar },
  data() {
    return {
      isActive: true,
      active: false,
      currentX: null,
      currentY: null,
      initialX: null,
      initialY: null,
      xOffset: 0,
      yOffset: 0,
      socialBarOpen: true,
      user: this.$store.getters.getUser
    };
  },
  methods: {
    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
        this.initialY = this.yOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
        this.initialY = this.yOffset;
      }

      if (e.target === document.getElementById("dragItem")) {
        this.active = true;
      }
    },
    dragEnd() {
      this.initialX = this.currentX;
      this.initialY = this.currentY;

      this.active = false;
    },
    drag(e) {
      if (this.active) {
        e.preventDefault();

        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
          this.currentY = this.initialY;
        } else {
          this.currentX = e.clientX - this.initialX;
          this.currentY = this.initialY;
        }

        this.xOffset = this.currentX;
        this.yOffset = this.currentY;

        this.setTranslate(
          this.currentX,
          this.currentY,
          document.getElementById("dragItem")
        );
      }
    },
    setTranslate(xPos, yPos, el) {
      el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
    },
    toggleSocialBar() {
      this.isActive = !this.isActive;
      this.socialBarOpen = !this.socialBarOpen;
    }
  },
  computed: {
    unseenNotificationCount() {
      return this.$store.getters.unseenNotificationCount;
    }
  },
  mounted() {
    const parentContainer = document.getElementById("app");
    parentContainer.addEventListener("touchstart", this.dragStart, false);
    parentContainer.addEventListener("touchend", this.dragEnd, false);
    parentContainer.addEventListener("touchmove", this.drag, false);

    parentContainer.addEventListener("mousedown", this.dragStart, false);
    parentContainer.addEventListener("mouseup", this.dragEnd, false);
    parentContainer.addEventListener("mousemove", this.drag, false);
  }
};
</script>
